import { OnboardingFormActions } from '../../../enums'
import { RemoveATMAction } from '../../../types/actions'

export const removeATM = ({ atmIndex, companyIndex }: { atmIndex: number; companyIndex: number }): RemoveATMAction => ({
  type: OnboardingFormActions.REMOVE_ATM,
  payload: { companyIndex, atmIndex }
})
